const initState = {
    files: [],
    complianceFiles: [],
};

const filesReducer = (state = initState, action) => {


    switch (action.type) {


        case "FILES":
            return {
                ...state,
                files: action.files,
            };

        case "COMPLIANCE_FILES":
            return {
                ...state,
                complianceFiles: action.files,
            };
    



        default:
            return state;
    }
};

export default filesReducer;
